import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Designer from "./pages/Designer";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Success from "./pages/Success";
import Steam from "./pages/Steam";
import KitDetail from "./pages/KitDetail";
import Bulk from "./pages/Bulk";
import Homecoming from "./pages/Homecoming";
import HerTurn from "./pages/HerTurn";
import GiftCards from "./pages/GiftCards";
import GiftCardSuccess from "./pages/GiftCardSuccess";
import { AdminOrderDetail, AdminCustomOrderDetail, AdminBulkQuoteDetail, AdminMessageDetail } from "./pages/AdminDetail";
import "./App.css";

const Shell = () => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/designer" element={<Designer />} />
        <Route path="/about" element={<About />} />
        <Route path="/steam" element={<Steam />} />
        <Route path="/steam/:slug" element={<KitDetail />} />
        <Route path="/bulk" element={<Bulk />} />
        <Route path="/homecoming" element={<Homecoming />} />
        <Route path="/her-turn" element={<HerTurn />} />
        <Route path="/gift-cards" element={<GiftCards />} />
        <Route path="/giftcard-success" element={<GiftCardSuccess />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/success" element={<Success />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
        <Route path="/admin/custom-orders/:id" element={<AdminCustomOrderDetail />} />
        <Route path="/admin/bulk-quotes/:id" element={<AdminBulkQuoteDetail />} />
        <Route path="/admin/messages/:id" element={<AdminMessageDetail />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Shell />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
